import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { IAcaoPlanoAcaoModel, IAcaoPlanoAcaoRecomendacaoModel, IPlanoAcaoModel, IRecomendacaoOsaExecucaoMatrizModel } from "./../../../../models/plano-acao-model";
import { PlanoAcaoService } from "./../../../../services/plano-acao.service";
import { BaseFormComponent } from "../../../../shared/components/base-form/base-form.component";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { BsLocaleService } from "ngx-bootstrap/datepicker";

@Component({
  selector: 'app-plano-acao-recomendacao',
  templateUrl: './plano-acao-recomendacao.component.html',
  styleUrls: ['./plano-acao-recomendacao.component.scss']
})

export class PlanoAcaoRecomendacaoComponent extends BaseFormComponent implements OnInit {

  public model = this.createModel();
  public tituloModal = "";

  constructor(
    public route: ActivatedRoute,
    public toastr: ToastrService,
    public router: Router,
    public localeService: BsLocaleService,
    public matDialog: MatDialog,
    public planoAcaoService: PlanoAcaoService,
    private dialogRef: MatDialogRef<PlanoAcaoRecomendacaoComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    super(route, toastr, router, localeService, matDialog);
    this.tituloModal = data?.titulo;
    this.model = data?.element;
  }

  ngOnInit(): void {
  }


  private createModel(): IAcaoPlanoAcaoRecomendacaoModel {
    return {
      id: 0,
      acaoId: 0,
      acao: {} as IAcaoPlanoAcaoModel,
      recomendacaoId: 0,
      recomendacao: {} as IRecomendacaoOsaExecucaoMatrizModel
    };
  }

  public fechar() {
    this.dialogRef.close();
  }

}

